// ISDP CUSTOM: one clipboard-copy helper with consistent toast feedback. Several copy buttons
// (notably the DevSecOps API-key copies) wrote to the clipboard with NO feedback at all, and others
// only flipped local "Copied!" text. This centralises: writeText → success/error toast.
import { useCallback } from 'react';
import { useToast } from './ToastProvider';

export function useCopyToClipboard(): (text: string | undefined | null, label?: string) => void {
  const toast = useToast();
  return useCallback(
    (text, label) => {
      if (!text) return;
      const done = () => toast.success(label ? `${label} copied` : 'Copied to clipboard');
      const fail = () => toast.error('Could not copy to clipboard');
      try {
        const p = navigator.clipboard?.writeText(text);
        if (p && typeof p.then === 'function') p.then(done).catch(fail);
        else done();
      } catch {
        fail();
      }
    },
    [toast],
  );
}
